export interface IGlobalStore {
  loading: boolean;
}

export default { loading: false } as IGlobalStore;
